module.exports = __webpack_public_path__ + "img/brand.77a2e10c.svg";